import Loading1 from './Loading1';

export const LoadingImproved = ({ onAnswer }) => {
    return (
        <Loading1 onAnswer={onAnswer} />
    )
};

export default LoadingImproved;
